import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconReload = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M27.237 7.685a25 25 0 0 0-5.637.961A24.53 24.53 0 0 0 6.597 21.24c-2.649 5.307-3.27 11.487-1.734 17.26 2.254 8.473 9.018 15.181 17.52 17.375 3.353.865 7.12 1.012 10.449.406 5.266-.957 9.979-3.518 13.606-7.393 1.395-1.491 2.803-3.43 3.013-4.146.204-.699-.076-1.545-.675-2.036-.739-.607-1.825-.605-2.547.005-.11.094-.412.48-.67.858-2.872 4.22-7.124 7.22-11.95 8.427-3.253.815-6.382.856-9.663.127-1.05-.233-2.828-.837-3.883-1.319-5.03-2.298-8.803-6.361-10.758-11.584-1.195-3.191-1.551-6.976-.98-10.404a20.66 20.66 0 0 1 4.258-9.52c.688-.86 2.21-2.391 3.033-3.05 3.066-2.456 6.595-3.946 10.528-4.447 1.178-.15 3.48-.15 4.717-.001 4.7.568 8.86 2.577 12.147 5.865a19.8 19.8 0 0 1 3.836 5.305c1.383 2.76 2.176 5.988 2.18 8.869v.636l-1.904-1.891c-1.744-1.733-1.935-1.903-2.274-2.029-.99-.366-2.13.095-2.55 1.033-.213.479-.213 1.231.002 1.678.12.251.946 1.115 3.84 4.019 4.162 4.175 4.004 4.045 4.902 4.045s.737.134 4.936-4.077c3.51-3.52 3.728-3.752 3.856-4.101.598-1.628-.969-3.206-2.584-2.603-.356.133-.524.282-2.278 2.025l-1.894 1.881-.042-1.106c-.136-3.543-.949-6.804-2.476-9.939A24.5 24.5 0 0 0 31.64 7.843c-.753-.098-2.771-.233-3.224-.216-.123.005-.654.03-1.179.058" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconReload.displayName = 'IconReload';